const state = {
  data: false,
  changeStaus: '0', // 0应聘者其他招聘者
  userInfo: {}
}
export default {
  state,
  mutations: {
    setChangeStaus(state, obj) {
      state.changeStaus = obj
    },
    setToken(state, obj) {
      state.data = obj
    },
    setUserInfo(state, obj) {
      state.userInfo = obj
    },
    setUserid(state, obj) {
      state.userid = obj
    }
  },
  actions: {
    setChangeStaus({ commit }, obj) {
      commit('setChangeStaus', obj)
    },
    setToken({ commit }, obj) {
      commit('setToken', obj)
    },
    setUserInfo({ commit }, obj) {
      commit('setUserInfo', obj)
    },
    setUserid({ commit }, obj) {
      commit('setUserid', obj)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/token/index.js